module.exports = __webpack_public_path__ + "img/inbox-announcement-approve.5dcac623.svg";